// Faqat shu qiymatni o'zgartiring: 'test' yoki 'quiz'
export const QUIZ_TERM: "test" | "quiz" = "test";

const t = QUIZ_TERM === "test";

export const siteUrl  = t ? "https://test.edu.uz"    : "https://survey.hemis.uz";
export const siteName = t ? "Test.edu.uz"            : "Survey.hemis.uz";

export const termLabels = {
  single:          t ? "Test"                                    : "So'rovnoma",
  plural:          t ? "Testlar"                                 : "So'rovnomalar",
  newPlural:       t ? "Yangi testlar"                           : "Yangi so'rovnomalar",
  inProgress:      t ? "Jarayondagi testlar"                     : "Jarayondagi so'rovnomalar",
  completed:       t ? "Yakunlangan testlar"                     : "Yakunlangan so'rovnomalar",
  start:           t ? "Testni boshlash"                         : "So'rovnomani boshlash",
  continue:        t ? "Testni davom ettirish"                   : "So'rovnomani davom ettirish",
  finishConfirm:   t ? "Testni yakunlashni tasdiqlaysizmi?"      : "So'rovnomani yakunlashni tasdiqlaysizmi?",
  answersSaved:    t ? "Test javoblaringiz muvaffaqiyatli saqlandi" : "So'rovnoma javoblaringiz muvaffaqiyatli saqlandi",
  completeWarning: t ? "Iltimos testni to'liq yakunklang!"       : "Iltimos so'rovnomani to'liq yakunklang!",
};
